import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { CommonFunctionService } from "./../../../services/Common/common-function.service";
import { UserMerchantData } from "./../../../services/Common/common-function.service";
import { PayoutService } from 'src/app/services/payout.service';
import { environment } from 'src/environments/environment';
const swal = require('sweetalert');
const _clone = (d) => JSON.parse(JSON.stringify(d));
@Component({
  selector: 'app-virtual-account-balances',
  templateUrl: './virtual-account-balances.component.html',
  styleUrls: ['./virtual-account-balances.component.scss']
})
export class VirtualAccountBalancesComponent implements OnInit {


  IDFCBankCurrentBalance:any;
IDFCBankUpdatedDatetime:any;
  IDFCBankAccountNo:any;
   IDFCBankBankRefereceId:any;
    IDFCBankAccountHolderName:any;
     IDFCBankBankCode:any;
     IDFCBankAddress:any;
      IDFCBankCity:any;
        IDFCBankState:any;
      IDFCBankZipCode:any;
      IDFCPayoutAccountKeyId:any;
  IDFCkbtn:boolean=true;
  IDFCBankinvalidetails:boolean=false;
  IDFCBankBalancedetails:boolean=false;
  IDFC=0;
  IDFCTab:boolean=false;
  IDFCInfo:boolean=false;

  PrimaryAccountProcessorValue=0;
  YesBankbtn:boolean=true;
  Axiskbtn:boolean=true;
  Indusbtn:boolean=true;
  CreateAccount:boolean=false;
  AxisBalancedetails:boolean=false;
  Axisinvalidetails:boolean=false;
  YesPayoutAccountKeyId:any;
  AxisPayoutAccountKeyId:any;
  YesBankBalancedetails:boolean=false;
  YesBankinvalidetails:boolean=false;
  IndusPayoutAccountKeyId:any;
  IndusBalancedetails:boolean=false;
 Indusinvalidetails:boolean=false;


  ZerpProcessors:boolean=false;
  processorlist=[];
  Yp=0;
  Ap=0;
  Ip=0
  ProcessorAccountdetails=[];
  YesBankTab:boolean=false;
  AxisTab:boolean=false;
  IndusTab:boolean=false;
  yesBankInfo:boolean=false;
  IndusBankInfo:boolean=false;
  IndusCurrentBalance:any;
  IndusUpdatedDatetime:any;
  IndusAccountNo:any;
 IndusBankRefereceId:any;
 IndusAccountHolderName:any;
 IndusBankCode:any;
 IndusAddress:any;
IndusCity:any;
 IndusState:any;
  IndusZipCode:any;

  AxisBankInfo:boolean=false;
  hidevirtualacct:boolean=false;
  AxisBankCurrentBalance:any;
  AxisBankUpdatedDatetime:any;
  AxisBankAccountNo:any;
  AxisBankBankRefereceId:any;
  AxisBankAccountHolderName:any;
  AxisBankBankCode:any;
  AxisBankAddress:any;
  AxisBankCity:any;
  AxisBankState:any;
  AxisBankZipCode:any;
  
  YesBankCurrentBalance:any;
  YesBankUpdatedDatetime:any;
  YesBankAccountNo:any;
  YesBankBankRefereceId:any;
  YesBankAccountHolderName:any;
  YesBankBankCode:any;
  YesBankAddress:any;
  YesBankCity:any;
  YesBankState:any;
  YesBankZipCode:any;


  Masknumber:boolean=true;
  Accountnumber:boolean=false;
  CreatePayOutSecurity:boolean=false;
  servicesslist=[];
  resellerno:any;
  step1 = true; 
  step2 = false;
  step3 = false; 
  Workclose= true;
  editing = {};
  TransactionList = [];
  rowsFilter = [];
  rowsExp = [];
  rowsSort = [];
  temp = [];
  expanded: any = {};
  timeout: any;
  rowsSel = [];
  selected = [];
  MerchantKeyId:any;
  loggedinuseremail:any;

  transactiondetails:boolean=false;
  invalidetails:boolean=false;
  Balancedetails:boolean=true;
  rows;
  viewid:any;
  fltrMerchantkeyId:any;
  constructor(private route: ActivatedRoute,private service: PayoutService, private commonfunction: CommonFunctionService) {
    this.route.params.subscribe(params => {
      this.viewid = params['Id'];
    });
    this.Processotdetails();
    let merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
    this.fltrMerchantkeyId = merchantdata.MerchantKeyId;
   }

  ngOnInit() {
    this.getTransactiondetails();
    this.createCustomerAccount();
    this.getUserPermissions();
  }
  Createbalance(value)
  {
    let form = {
      MerchantKeyId: 0 , ProcessorId:0,};
      let merchantdatas: UserMerchantData = this.commonfunction.getUserMerchantData();
      if(value==1)
      {
        form.ProcessorId = 1;
      }
      else if(value==2)
      {
        form.ProcessorId = 2;
      }
      else if(value==3)
      {
        form.ProcessorId = 3;
      }
      else if(value==4)
      {
        form.ProcessorId = 4;
      }
      form.MerchantKeyId =  this.fltrMerchantkeyId;

    this.service.AddVirtualAccountBalance(form).subscribe(result => {
      if(result !=null)
      {
        // swal("Added", "Account Create Scucessfully", "success");
        // window.location.reload();
        this.openConfirmationDialog();
      }
    })
  }


  openConfirmationDialog() {
    
    swal({
      title: 'Virtual account created successfully',
      text: '',
      icon: 'success',
      buttons: {
        
          confirm: {
              text: 'Ok',
              value: true,
              visible: true,
              className: "",
              closeModal: true
          }
      }
  }).then((isConfirm) => {
      if (isConfirm) {
      window.location.reload();
      }
    
  });
  
  }


  // TransactionHistory()
  // {
  //   this.transactiondetails=true;
  // }

  next2() {
    this.step1 = false; 
    this.step2 = true;  
    this.step3 = false; 
  }
  next3() {
    this.step1 = false; 
    this.step2 = false;  
    this.step3 = true; 
  }
   
  back1(){
    this.step1 = true; 
    this.step2 = false;
    this.step3 = false;
     
  }
  back2(){
    this.step1 = false; 
    this.step2 = true;
    this.step3 = false;
     
  }
  back3(){
    this.step1 = false; 
    this.step2 = false;
    this.step3 = true;
     
  }
  close(){
    this.Workclose= false;
  }
  TransactionHistory()
  {
    this.transactiondetails=!this.transactiondetails
    if( this.transactiondetails==true)
    {
      this.transactiondetails=true;
    
    }
    else{
      this.transactiondetails=false;
    
    }
  }


  getTransactiondetails() {
    let merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
    this.loggedinuseremail = this.commonfunction.getUserId();
    // this.loggedinuseremail=null;
    
  this.MerchantKeyId = merchantdata.MerchantKeyId;
  
    this.GetTransactionList((data) => {
      // cache our list
  


    });
  }
  GetTransactionList(cb) {
    const req = new XMLHttpRequest();
    this.service.GetRecentTransactionList(this.MerchantKeyId,this.loggedinuseremail).subscribe(data => {

if(data !=null)
{
  this.temp = _clone(data);
  this.TransactionList = _clone(data);;
  this.rowsFilter = _clone(data);;
  this.rowsExp = _clone(data);
  this.rowsSort = _clone(data);
  this.rowsSel = _clone(data);



  this.TransactionList.forEach(element => {
    if (element.AccountNumber !=null) {
    var first6digits = element.AccountNumber.slice(0, 6);
   var last4digits = element.AccountNumber.slice(-4);
      element.AccountNumber = first6digits+"-XXXXXXX-"+last4digits;
    }
   
  });
}


    });
    // req.open('GET', environment.GetRecentTransactionList + "?MerchantKeyId=" + this.MerchantKeyId + "&UserId="+this.loggedinuseremail);
   
    // req.onload = () => {
    //   cb(JSON.parse(req.response));
    // };

    // req.send();
  }



  createCustomerAccount()
  {
    this.MerchantKeyId = this.commonfunction.getUserMerchantData().MerchantKeyId;
    this.resellerno =this.commonfunction.getUserMerchantData().ResellerId;
  this.service.getMerchantServicesAndFees(this.MerchantKeyId,this.resellerno).subscribe(result => {
    this.servicesslist = _clone(result);;
    this.servicesslist.forEach(element => {
       if (element.FeeCode == "CAFA001" && element.Status==1)
        {
              this.Masknumber=false;
              this.Accountnumber=true;
        }
      });

  });
  
  }
 
 
Processotdetails()
{
  let merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
  this.service.GetPayoutprocessor(merchantdata.MerchantKeyId).subscribe(res => {

    if(res !=null)
    {
      this.Getdetails()
    }
    if(res.length>0)
    {
      this.processorlist=res;
      res.forEach(element => {
        if (element.PayoutProcessorId == 1 && element.Status==1) 
        {
          this.IndusTab=true;
          if(element.IsDefault==1)
          {
           this.Indusbtn=false;
          }
        }
        if (element.PayoutProcessorId == 2 && element.Status==1) 
        {
          this.YesBankTab=true;
          if(element.IsDefault==1)
          {
            this.YesBankbtn=false;
            
          }
        }
        if (element.PayoutProcessorId == 3 && element.Status==1) 
        {
          this.AxisTab=true;
          if(element.IsDefault==1)
          {
            this.Axiskbtn=false;
          }
        }
        if (element.PayoutProcessorId == 4 && element.Status==1) 
        {
          this.IDFCTab=true;
          if(element.IsDefault==1)
          {
            this.IDFCkbtn=false;
          }
        }
      });

    }
    else
    {
      this.ZerpProcessors=true;
    }
  });
}

gotoYesbankprocessor()
{
  this.IndusBankInfo=false;
  this.yesBankInfo=true;
  this.AxisBankInfo=false;
}

gotoIndusCardProcessing()
{
this.IndusBankInfo=true;
this.yesBankInfo=false;
this.AxisBankInfo=false;
}

gotoAxisCardProcessing()
{
  this.IndusBankInfo=false;
  this.yesBankInfo=false;
  this.AxisBankInfo=true;
}
gotoIDFCCardProcessing()
{
  this.IndusBankInfo=false;
  this.yesBankInfo=false;
  this.AxisBankInfo=false;
  this.IDFCInfo=true;
}
 



Getdetails()
{
  let merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
  this.service.ViewAccountBalance(merchantdata.MerchantKeyId).subscribe(result => {
    if(result.length>0)
    {

      this.ProcessorAccountdetails=result;
      this.ProcessorAccountdetails.forEach(element => {

        if (element.PayOutProcessor == 1) 
        {
          this.Ip=1;
          this.IndusBankInfo=true;
         this.IndusCurrentBalance=element.CurrentBalance;
         this.IndusUpdatedDatetime=element.UpdatedDatetime;
         this.IndusAccountNo=element.AccountNo;
         this.IndusBankRefereceId=element.BankRefereceId;
         this.IndusPayoutAccountKeyId=element.PayoutAccountKeyId;
          if(this.IndusBankRefereceId=="Indus")
          {
            this.IndusBankRefereceId="Indusind Bank";
          }
         this.IndusAccountHolderName=element.AccountHolderName;
         this.IndusBankCode=element.BankCode;
         this.IndusAddress=element.Address;
         this.IndusCity=element.City;
         this.IndusState=element.State;
         this.IndusZipCode=element.ZipCode;
        } 
        else if (element.PayOutProcessor == 2) {
          // this.YesBankTab=true;
          this.Yp=1;
           this.yesBankInfo=true;
          this.YesBankCurrentBalance=element.CurrentBalance;
          this.YesBankUpdatedDatetime=element.UpdatedDatetime;
          this.YesBankAccountNo=element.AccountNo;
          this.YesBankBankRefereceId=element.BankRefereceId;
          this.YesBankAccountHolderName=element.AccountHolderName;
          this.YesBankBankCode=element.BankCode;
          this.YesBankAddress=element.Address;
          this.YesBankCity=element.City;
          this.YesBankState=element.State;
          this.YesBankZipCode=element.ZipCode;
          this.YesPayoutAccountKeyId=element.PayoutAccountKeyId;
       
        }
        else if (element.PayOutProcessor == 3)
         {
          // this.AxisTab=true;
          this.Ap=1;
          this.AxisBankInfo=true;
          this.AxisBankCurrentBalance=element.CurrentBalance;
          this.AxisBankUpdatedDatetime=element.UpdatedDatetime;
          this.AxisBankAccountNo=element.AccountNo;
          this.AxisBankBankRefereceId=element.BankRefereceId;
          this.AxisBankAccountHolderName=element.AccountHolderName;
          this.AxisBankBankCode=element.BankCode;
          this.AxisBankAddress=element.Address;
          this.AxisBankCity=element.City;
          this.AxisBankState=element.State;
          this.AxisBankZipCode=element.ZipCode;
          this.AxisPayoutAccountKeyId=element.PayoutAccountKeyId;
        }
        else if (element.PayOutProcessor == 4)
        {
         this.IDFC=1;
         this.IDFCInfo=true;
         this.IDFCBankCurrentBalance=element.CurrentBalance;
         this.IDFCBankUpdatedDatetime=element.UpdatedDatetime;
         this.IDFCBankAccountNo=element.AccountNo;
         this.IDFCBankBankRefereceId=element.BankRefereceId;
         this.IDFCBankAccountHolderName=element.AccountHolderName;
         this.IDFCBankBankCode=element.BankCode;
         this.IDFCBankAddress=element.Address;
         this.IDFCBankCity=element.City;
         this.IDFCBankState=element.State;
         this.IDFCBankZipCode=element.ZipCode;
         this.IDFCPayoutAccountKeyId=element.PayoutAccountKeyId;
       }
      });


      if(this.Ip==1)
      {
        this.IndusBalancedetails=true;
        this.Indusinvalidetails=false;
      }
      else
      {
        this.IndusBalancedetails=false;
        this.Indusinvalidetails=true;
        
       
      }
      if(this.Ap==1)
      {
        this.Axisinvalidetails=false;
        this.AxisBalancedetails=true;

      }
      else{
       
        this.Axisinvalidetails=true;
        this.AxisBalancedetails=false;
      
      }
      if(this.Yp==1)
      {
        this.YesBankBalancedetails=true;
        this.YesBankinvalidetails=false;

      }
      else{
       
        this.YesBankBalancedetails=false;
        this.YesBankinvalidetails=true;
       
      }
      if(this.IDFC==1)
      {
        this.IDFCBankBalancedetails=true;
        this.IDFCBankinvalidetails=false;
 
      }
      else{
       
        this.IDFCBankBalancedetails=false;
        this.IDFCBankinvalidetails=true;
       
      }

      if(this.YesBankTab==true)
      {
        this.gotoYesbankprocessor();
      }
      if(this.AxisTab==true)
      {
        this.gotoAxisCardProcessing();
      }
      if(this.IndusTab==true)
      {
        this.gotoIndusCardProcessing();
      }

      // this.rows=result;
      // if(this.rows.BankRefereceId=="Indus")
      // {
      //   this.rows.BankRefereceId="Indusind Bank";
      // }
      
    }
    else{
      this.invalidetails=true;
      this.Balancedetails=false;
      if(this.Ip==1)
      {
        this.IndusBalancedetails=true;
        this.Indusinvalidetails=false;
      }
      else
      {
        this.IndusBalancedetails=false;
        this.Indusinvalidetails=true;
       
      }
      if(this.Ap==1)
      {
        this.Axisinvalidetails=false;
        this.AxisBalancedetails=true;
      }
      else{
        this.Axisinvalidetails=true;
        this.AxisBalancedetails=false;
      
      }
      if(this.Yp==1)
      {
        this.YesBankBalancedetails=true;
        this.YesBankinvalidetails=false;

      }
      else{
       
        this.YesBankBalancedetails=false;
        this.YesBankinvalidetails=true;
       
      }
      if(this.IDFC==1)
      {
        this.IDFCBankBalancedetails=true;
        this.IDFCBankinvalidetails=false;
 
      }
      else{
       
        this.IDFCBankBalancedetails=false;
        this.IDFCBankinvalidetails=true;
       
      }

      if(this.YesBankTab==true)
      {
        this.gotoYesbankprocessor();
      }
      if(this.AxisTab==true)
      {
        this.gotoAxisCardProcessing();
      }
      if(this.IndusTab==true)
      {
        this.gotoIndusCardProcessing();
      }
      if(this.IDFCTab==true)
      {
        this.gotoIDFCCardProcessing();
      }
    }
 
  }) 
}

getUserPermissions() {
  const merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
  this.service.GetuserRoleBasedPermissions(merchantdata.UserId, "Merchant").subscribe(result => {
    if (result != null) {
      for (var i in result) {
        if (result[i].UserPermission == 'PayOut') {
          var type = result[i].Type;
          if (type == 'R') 
          {
              
              this.CreateAccount=false;
              
             
          }
         else if (type == 'RW') 
          {
            this.CreateAccount=true;
            if(merchantdata.UserType !='Reseller' && merchantdata.UserType !='ResellerUser')
            {
              this.hidevirtualacct = true;
              
            }
            else{
              this.hidevirtualacct = false;
             
            }
          }
         else if (type == 'RWD') 
          {
            this.CreateAccount=true;
            if(merchantdata.UserType !='Reseller' && merchantdata.UserType !='ResellerUser')
            {
              this.hidevirtualacct = true;
            
            }
            else{
              this.hidevirtualacct = false;
              
            }
          }
        }
      }

    }

  });
}


DefaultAccount()
{
  let form = {
    Id: 0,
    MerchantkeyId: 0,
    PayoutAccountKeyId: "",
    PayoutProcessorId: 0,
    Status: 0,
    UpdatedUserName: "",
    UpdatedDatetime: "",
    IsDefault: 0,
    DailyAmountLimit: 0,
    PerAccountTransactionLimit: 0,
    LoginUserId:''
  };
  let merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
  form.PayoutProcessorId=this.PrimaryAccountProcessorValue;
  form.MerchantkeyId=merchantdata.MerchantKeyId;
  form.LoginUserId = this.commonfunction.getUserMerchantData().UserId;
  this.service.PayoutconfigDefaultAccount(form).subscribe(result => {
    if(result!=null)
    {
       window.location.reload();
    }
  });
}


opendialogbox(value)
{
  this.PrimaryAccountProcessorValue=value;
  swal({
    title: 'Do you want to change Primary bank?',
    text: '',
    icon: 'warning',
    buttons: {
      cancel: {
        text: 'Cancel',
        value: null,
        visible: true,
        className: "",
        closeModal: true
      },
      confirm: {
        text: 'Yes',
        value: true,
        visible: true,
        className: "bg-danger",
        closeModal: true
      }
    }
  }).then((isConfirm) => {
    if (isConfirm) {
      this.DefaultAccount()
    }

  });
}
}
